import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_dashboard/travel-agency")({
  component: TravelAgencyPage,
});

/** TravelAgencyOffices.vue is a 100% mock commented out of the Vue nav — kept as placeholder. */
function TravelAgencyPage() {
  return (
    <div className="p-6" data-vue-source="pages/TravelAgencyOffices.vue">
      <h1 className="text-2xl font-semibold">Agence de voyage</h1>
      <p className="mt-2 text-sm text-muted-foreground">Cette page héritée n'est pas encore migrée.</p>
    </div>
  );
}
